import { PersonsAddressAddressChangesService_personAddressChangeServiceGetEntities as service } from '@festina/legalentity-general-types/legalentity/hooks/PersonsAddressAddressChangesService_personAddressChangeServiceGetEntities'

export const useFetchAddressChanges = service.useSuspenseQuery
